import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_API_TOAST = new HttpContextToken<boolean>(() => false);
